import { EndpointType } from "app/pages/app-intelligence/constants";
import { DefaultFetchService } from "app/services/fetchService";
import queryString from "query-string";
import dayjs from "dayjs";
import { swSettings } from "app/common/services/swSettings";
import { apiFormat } from "@similarweb/pro-logic-components";
import type {
    IHistoricalRetentionResponse,
    IRetentionOverTimeResponse,
} from "app/pages/app-intelligence/app-analysis/pages/Retention/types";

const MAX_MONTHS_TO_SHOW = 12;

const fetchService = DefaultFetchService.getInstance();

export const getEndpoint = (type: EndpointType | string, params?: any) => {
    const res = `/api/AppRetention/${type}`;
    if (params) {
        return `${res}?${queryString.stringify(params)}`;
    }
    return res;
};

const getChartData = async (params) => {
    const endpoint = getEndpoint(EndpointType.GRAPH);
    return fetchService.get<IRetentionOverTimeResponse>(endpoint, params);
};

const getTableData = async (params) => {
    const endpoint = getEndpoint(EndpointType.TABLE);
    return fetchService.get<IHistoricalRetentionResponse>(endpoint, params);
};

const getExcelEndpoint = (params, baseType: EndpointType) => getEndpoint(`${baseType}/${EndpointType.EXCEL}`, params);

// The backend implementation for this endpoint requires the front-end
// to send the "to" query param 1 month in advance.
const getDurationValuesForTableRequest = (componentId?) => {
    const component = componentId ? swSettings.components[componentId] : swSettings.current;
    const firstAvailableDataDate = dayjs(component.resources.FirstAvailableDate);
    const calculatedStartDate = dayjs(component.endDate).subtract(MAX_MONTHS_TO_SHOW, "months");
    const actualFromDate = firstAvailableDataDate.isAfter(calculatedStartDate)
        ? firstAvailableDataDate
        : calculatedStartDate;
    const requestFromDate = actualFromDate.add(1, "months").format(apiFormat);
    return {
        from: requestFromDate,
        to: dayjs(component.endDate).add(1, "months").endOf("month").format(apiFormat),
    };
};

// The backend implementation for this endpoint requires the front-end
// to send the interval query params 1 month in advance.
const getDurationValuesForChartRequest = (from: string, to: string) => ({
    from: dayjs(from, apiFormat).add(1, "months").format(apiFormat),
    to: dayjs(to, apiFormat).add(1, "months").endOf("month").format(apiFormat),
});

export const AppRetentionApiService = {
    getChartData,
    getTableData,
    getExcelEndpoint,
    getDurationValuesForTableRequest,
    getDurationValuesForChartRequest,
};
